/* ============================================================
   CueChip — TASK-255: the one scannable state chip shared by the
   customer order list/detail (TASK-252/255) and the provider queue
   cards (TASK-253) — identical shape and tones everywhere so the
   surfaces never disagree. Light theme, Montserrat, iOS-18 minimal
   per DESIGN-SYSTEM.md.
   ============================================================ */

export type CueTone = 'neutral' | 'accent' | 'success' | 'danger';

export function CueChip({ label, tone }: { label: string; tone: CueTone }) {
  const color =
    tone === 'accent' ? 'var(--color-primary)'
      : tone === 'success' ? 'var(--color-success)'
        : tone === 'danger' ? 'var(--color-danger)'
          : 'var(--color-text-secondary)';
  return (
    <span
      style={{
        padding: '4px 10px',
        borderRadius: 'var(--radius-pill)',
        border: tone === 'neutral' ? '1px solid var(--color-separator)' : 'none',
        background: tone === 'neutral' ? 'var(--color-surface)' : 'var(--color-bg)',
        fontSize: 'var(--fs-caption)',
        fontWeight: 'var(--fw-medium)',
        color,
      }}
    >
      {label}
    </span>
  );
}
